/**
 * Service History API — real backend calls.
 * See BACKEND_CONTRACT.md.
 */

import axiosInstance from './axiosInstance';

/**
 * List services the user has received.
 *
 * BACKEND: GET /service-history
 * QUERY:   ?from=&to=&status=&page=&pageSize=
 * SUCCESS: { data: { history: [...] }, meta: { total } }
 *
 * @param {object} [params]
 */
export async function listHistory(params = {}) {
  const res = await axiosInstance.get('/service-history', { params });
  return res.data;
}

/**
 * Get full details for one history entry.
 *
 * BACKEND: GET /service-history/:id
 * SUCCESS: { data: { entry: {...} } }
 *
 * @param {string} id
 */
export async function getHistoryEntry(id) {
  const res = await axiosInstance.get(`/service-history/${id}`);
  return res.data.data.entry;
}

export const serviceHistoryApi = { listHistory, getHistoryEntry };
export default serviceHistoryApi;
